import { Component } from '@angular/core';

import { UpdatePartnerComponent } from '../update-partner/update-partner.component';
import { ListPartnerCustomersComponent } from '../list-partner-customers/list-partner-customers.component';
@Component({
    selector: 'app-partner-customers',
    templateUrl: './partner-customers.component.html',
    styleUrls: ['./partner-customers.component.css'],
    imports: [UpdatePartnerComponent, ListPartnerCustomersComponent]
})
export class PartnerCustomersComponent {
  partnerData: any;
  
  ngOnInit() {
    this.partnerData = history.state.partnerData;
  }
}
